module.exports = {
  UNUSED: 'unused',
  WEAR_AND_TEAR: 'wear-and-tear',
  VERY_USED: 'very-used',
};
